import { SxProps, Theme } from '@mui/system';

const size = 36;

const styles = {
  marker: {
    height: size,
    width: size,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: size / 2,
  },
  markerText: {
    color: 'white',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
